import styled from 'styled-components';

import CCSModal from '@ey/canvascoreservices/Modal';

export default styled(CCSModal)`
	.motif-modal-body {
		display: flex;
		flex-direction: column;
	}
`;
